import {
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  setShowNavbar,
  unsetShowNavbar,
} from "../../../store/navbar/navbar.slice";
import { colors } from "../../../constants/colors";
import { useTranslation } from "react-i18next";
import { routeName } from "../../../routes/routeName";
import { iconsNavbar, iconsHeader, icons } from "../../../assets/icons/icons";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import MessageIcon from '@mui/icons-material/Message';
import VerticalSplitIcon from '@mui/icons-material/VerticalSplit';
import UndoIcon from '@mui/icons-material/Undo';
import SettingsIcon from '@mui/icons-material/Settings';
import CollectionsIcon from '@mui/icons-material/Collections';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import ForumIcon from '@mui/icons-material/Forum';
import BorderColorIcon from '@mui/icons-material/BorderColor';
// import { permission_config_data } from "./permission.config";
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { checkPermission } from "../../../utils/app.utils";
import { USER_TYPE } from "./enum";

const drawerWidth = 270;

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-start",
}));
interface permission_type {
  isCreate: boolean;
  isUpdate: boolean;
  isDelete: boolean;
  isView: boolean;
  code?: string;
}
interface SubItem extends permission_type {
  text: string;
  icon: any;
  index?: number;
  action?: () => void;
  subItems?: SubItem[];
  pathName: string;
  code?: string;
  permission: string[];
  checkPermission?: boolean
}


interface ListItem {
  text: string;
  icon: JSX.Element | null;
  subItems?: SubItem[];
  index?: number;
  action?: () => void;
  pathName: string;
  code?: string;
  permission: string[];
  isCreate: boolean;
  isUpdate: boolean;
  isDelete: boolean;
  isView: boolean;
}

const Navbar = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const location = useLocation();
  const currentPath: string = location.pathname;
  const theme = useTheme();
  const open = useSelector((state: any) => state?.navbar?.open);
  const dispatch = useDispatch();
  const matches = useMediaQuery("(max-width:750px)");
  const fullScreen = useMediaQuery(`(max-width:1400px)`);
  // const permission_config = permission_config_data({ t });

  const { profile } = useSelector((state: any) => state.profile);
  const permission: any[] = profile?.permission || [];
  const [expanded, setExpanded] = useState<{ [key: string]: boolean }>({});
  const [userRole, setUserRole] = useState<string>("");

  useEffect(() => {
    if (profile) {
      setUserRole(profile.user_type ?? "");
    }
  }, [profile]);

  const listItemsCmsWebsite: ListItem[] = [
    {
      text: t("TOPIC.MANAGE_WEB_SITE"),
      icon: <AccountTreeIcon />,
      action: undefined,
      pathName: "",
      code: "MANAGE_WEB_SITE",
      isCreate: false,
      isDelete: false,
      isUpdate: false,
      isView: true,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      subItems: [
        {
          icon: <icons.DashboardIcon />,
          pathName: routeName.cms_website.dashboard,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.MANAGE_WEB_SITE_DASHBOARD"),
          action: () => navigate(routeName.cms_website.dashboard),
          isCreate: false,
          isUpdate: false,
          isDelete: false,
          isView: true,
          code: "MANAGE_WEB_SITE.DASHBOARD"
        },
        {
          icon: <MessageIcon />,
          pathName: routeName.cms_website.intro,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.MANAGE_WEB_SITE_INTRO"),
          code: "MANAGE_WEB_SITE_INTRO",
          action: () => navigate(routeName.cms_website.intro),
          isCreate: false,
          isUpdate: true,
          isDelete: false,
          isView: true,
        },
        {
          icon: <VerticalSplitIcon />,
          pathName: "#",
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "โครงสร้างเว็บไซต์",
          code: "WEBSITE_STRUCTURE",
          isCreate: false,
          isUpdate: false,
          isDelete: false,
          isView: true,
          action: undefined,
          subItems: [
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_header,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "Header",
              action: () => navigate(routeName.cms_website.website_structure_header),
              code: "WEBSITE_STRUCTURE_HEADER",
              isCreate: false,
              isUpdate: true,
              isDelete: false,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_footer,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "Footer",
              action: () => navigate(routeName.cms_website.website_structure_footer),
              code: "WEBSITE_STRUCTURE_FOOTER",
              isCreate: false,
              isUpdate: true,
              isDelete: false,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_menu_header,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "Menu Header",
              action: () => navigate(routeName.cms_website.website_structure_menu_header),
              code: "WEBSITE_STRUCTURE_MENU_HEADER",
              isCreate: false,
              isUpdate: true,
              isDelete: false,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_banner_slide_list,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: t("TOPIC.MANAGE_WEB_SITE_BANNER_SLIDE"),
              action: () => navigate(routeName.cms_website.website_structure_banner_slide_list),
              code: "WEBSITE_STRUCTURE_BANNER_SLIDE",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_contact,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: t("TOPIC.MANAGE_WEB_SITE_BANNER_CONTACT"),
              action: () => navigate(routeName.cms_website.website_structure_contact),
              code: "WEBSITE_STRUCTURE_CONTACT",
              isCreate: false,
              isUpdate: true,
              isDelete: false,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.website_structure_content,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "จัดการเนื้อหา",
              action: () => navigate(routeName.cms_website.website_structure_content),
              code: "WEBSITE_STRUCTURE_CONTENT",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
          ]
        },
        {
          icon: <CalendarMonthIcon />,
          pathName: routeName.cms_website.calendar_activity,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "ปฏิทินกิจกรรม",
          action: () => navigate(routeName.cms_website.calendar_activity),
          code: "WEBSITE_STRUCTURE_CALENDAR_ACTIVITY",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <ForumIcon />,
          pathName: routeName.cms_website.content_news,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "ข่าวประชาสัมพันธ์",
          action: () => navigate(routeName.cms_website.content_news),
          code: "WEBSITE_STRUCTURE_CONTENT_NEWS",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <ThumbUpOutlinedIcon />,
          pathName: routeName.cms_website.poll_vote,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "โพลโหวต",
          action: () => navigate(routeName.cms_website.poll_vote),
          code: "WEBSITE_STRUCTURE_POLL_VOTE",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <BorderColorIcon />,
          pathName: routeName.cms_website.admission_form,
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "Admission",
          action: () => navigate(routeName.cms_website.admission_form),
          code: "WEBSITE_STRUCTURE_ADMISSION",
          isCreate: false,
          isUpdate: true,
          isDelete: false,
          isView: true,
        },
        {
          icon: <CollectionsIcon />,
          pathName: "",
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "แกลเลอรี",
          action: undefined,
          code: "WEBSITE_STRUCTURE_GALLERY",
          isCreate: false,
          isUpdate: false,
          isDelete: false,
          isView: true,
          subItems: [
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.collection_image,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "ภาพถ่าย",
              action: () => navigate(routeName.cms_website.collection_image),
              code: "WEBSITE_STRUCTURE_GALLERY_IMAGE",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.collection_vdo,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "วีดีโอ",
              action: () => navigate(routeName.cms_website.collection_vdo),
              code: "WEBSITE_STRUCTURE_GALLERY_VIDEO",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
          ]
        },
        {
          text: 'ความคิดเห็นจากศิษย์เก่า',
          icon: (
            <img
              src={iconsNavbar.courseManagementIcon}
              alt="courseManagementIcon"
            />
          ),
          action: () => navigate(routeName.cms_website.comment),
          pathName: routeName.cms_website.comment,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          code: "WEBSITE_STRUCTURE_WEBSITE_COMMENT",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          text: 'เครือข่ายความร่วมมือ',
          icon: (
            <img
              src={iconsNavbar.courseManagementIcon}
              alt="courseManagementIcon"
            />
          ),
          action: () => navigate(routeName.cms_website.collaborationNetwork),
          pathName: routeName.cms_website.collaborationNetwork,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          code: "WEBSITE_STRUCTURE_COLLABORATION_NETWORK",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },

        {
          icon: <SettingsIcon />,
          pathName: "",
          permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
          text: "ตั้งค่า",
          action: undefined,
          code: "WEBSITE_STRUCTURE_SETTING",
          isCreate: false,
          isUpdate: false,
          isDelete: false,
          isView: true,
          subItems: [
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.setting_manage_tag,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "จัดการแท็ก",
              action: () => navigate(routeName.cms_website.setting_manage_tag),
              code: "WEBSITE_STRUCTURE_MANAGE_TAGS",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.setting_manage_file,
              permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
              text: "จัดการไฟล์",
              action: () => navigate(routeName.cms_website.setting_manage_file),
              code: "WEBSITE_STRUCTURE_MANAGE_FILE",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.ActivityCategoriesManagement,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("หมวดหมู่กิจกรรม"),
              action: () => navigate(routeName.cms_website.ActivityCategoriesManagement),
              code: "WEBSITE_STRUCTURE_ACTIVITY_CATEGORIES_MANAGEMENT",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.NewsCategoriesManagement,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("หมวดหมู่ข่าว"),
              action: () => navigate(routeName.cms_website.NewsCategoriesManagement),
              code: "WEBSITE_STRUCTURE_NEWS_CATEGORIES_MANAGEMENT",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            // {
            //   icon: <UndoIcon sx={{ rotate: "180deg" }} />,
            //   pathName: routeName.cms.manageDocuments,
            //   permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
            //   text: t("จัดการแท็ก"),
            //   action: () => navigate(routeName.cms.TagManagement),
            // },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.PollCategoriesManagement,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("หมวดหมู่โพลโหวต"),
              action: () => navigate(routeName.cms_website.PollCategoriesManagement),
              code: "WEBSITE_STRUCTURE_POLL_CATEGORY_TYPE",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.GalleryTypeManagement,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("หมวดหมู่แกลเลอรี"),
              action: () => navigate(routeName.cms_website.GalleryTypeManagement),
              code: "WEBSITE_STRUCTURE_GALLERY_TYPE_MANAGEMENT",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            // {
            //   icon: <img src={iconsNavbar.icon2} alt="icon2" />,
            //   pathName: routeName.cms.GalleryTypeManagement,
            //   permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
            //   text: t("จัดการไฟล์"),
            //   action: () => navigate(routeName.cms.GalleryTypeManagement),
            // },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.permission,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("จัดการบทบาทผู้ใช้งาน"),
              action: () => navigate(routeName.cms_website.permission),
              code: "WEBSITE_STRUCTURE_PERMISSION",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.employee,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("จัดการบัญชีผู้ใช้เจ้าหน้าที่"),
              action: () => navigate(routeName.cms_website.employee),
              code: "WEBSITE_STRUCTURE_EMPLOYEE",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
            {
              icon: <UndoIcon sx={{ rotate: "180deg" }} />,
              pathName: routeName.cms_website.loginLog,
              permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
              text: t("ประวัติการใช้งาน"),
              action: () => navigate(routeName.cms_website.loginLog),
              code: "WEBSITE_STRUCTURE_HISTORY",
              isCreate: true,
              isUpdate: true,
              isDelete: true,
              isView: true,
            },
          ]
        },
      ],
    },
  ]
  const listItems: ListItem[] = [
    {
      text: t("IBSC Online Admission"),
      icon: <img src={iconsNavbar.icon1} alt="icon1" />,
      action: () => navigate(routeName.admission.IBSCOnlineAdmission),
      pathName: routeName.admission.IBSCOnlineAdmission,
      permission: ["ALL", "MEMBER"],
      code: "ONLINE_ADMISSIONS",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("Application History"),
      icon: <img src={iconsNavbar.video_time} alt="icon1" />,
      action: () => navigate(routeName.admission.HistoryOnlineAdmission),
      pathName: routeName.admission.HistoryOnlineAdmission,
      permission: ["ALL", "MEMBER"],
      code: "HISTORY_ONLINE_ADMISSIONS",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("รายชื่อผู้สมัคร"),
      icon: <img src={iconsNavbar.icon1} alt="icon1" />,
      action: () => navigate(routeName.admission.list_applicants),
      pathName: routeName.admission.list_applicants,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "LIST_APPLICANTS",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
    },
    {
      text: t("ระบบคำร้อง"),
      icon: <img src={iconsNavbar.clipboard_text} alt="icon2" />,
      action: () => navigate(routeName.request_form.visa_request),
      pathName: routeName.request_form.visa_request,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
      code: "ManageRequestForms",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.visa_request,
          permission: ["ALL", "STUDENT"],
          text: t("ส่งคำร้อง"),
          code: "ManageRequestFormsVisaRequest",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
          action: () => navigate(routeName.request_form.visa_request),
        },
        // ...[...Array(9).keys()].filter((x) => ![0, 7].includes(x)).map((x) => {
        //   return {
        //     icon: <UndoIcon sx={{ rotate: "180deg" }} />,
        //     pathName: routeName.request_form.manage_request,
        //     permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
        //     text: t("จัดการข้อมูลคำร้อง"),
        //     action: () => navigate(routeName.request_form.manage_request,{state: {
        //       id_visa_step: x + 1
        //     }}),
        //   }
        // }),
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_2',
          text: t("จัดการข้อมูลคำร้อง (ผู้ประสานงานฯ)"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 2
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_3',
          text: t("จัดการข้อมูลคำร้อง  (เจ้าหน้าที่สารบรรณ)"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 3
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_4',
          text: t("จัดการข้อมูลคำร้อง (เจ้าหน้าที่หอพัก)"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 4
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการข้อมูลคำร้อง (เจ้าหน้าที่กองกิจฯ)"),
          checkPermission: true,
          code: 'manage_request_5',
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 5
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_6',
          text: t("จัดการข้อมูลคำร้อง (เจ้าหน้าที่กองวิเทศฯ)"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 6
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_7',
          text: t("จัดการข้อมูลคำร้อง (เจ้าหน้าที่ทะเบียน)"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 7
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },


        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          checkPermission: true,
          code: 'manage_request_8',
          text: t("จัดการคำร้องขอลา"),
          action: () => navigate(routeName.request_form.manage_request, {
            state: {
              id_visa_step: 8
            }
          }),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_request_forms,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการฟอร์มคำร้อง"),
          action: () => navigate(routeName.request_form.manage_request_forms),
          isCreate: true,
          code: 'MANAGE_REQUEST_FORMS',
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.visa_intendant,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการผู้ดูแลหลักสูตร"),
          action: () => navigate(routeName.request_form.visa_intendant),
          code: 'VISA_INTENDANT',
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.request_form.manage_payment_channels_visa,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการช่องทางชำระเงินคำร้อง QE"),
          action: () => navigate(routeName.request_form.manage_payment_channels_visa),
          code: 'MANAGE_PAYMENT_CHANNELS_VISA',
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },

      ]
    },
    {
      text: t("การสอบเข้า"),
      icon: <img src={iconsNavbar.clipboard_text} alt="icon2" />,
      action: () => navigate(routeName.admission.manage_exams),
      pathName: routeName.admission.manage_exams,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "EntranceExamination",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      subItems: [
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.admission.manage_exams,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการข้อสอบ"),
          action: () => navigate(routeName.admission.manage_exams),
          code: "manage_exams",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.admission.period_examination,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("เปิดรอบการสอบ"),
          action: () => navigate(routeName.admission.period_examination),
          code: "period_examination",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.admission.interview_student,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("สอบสัมภาษณ์"),
          action: () => navigate(routeName.admission.interview_student),
          code: "interview_student",
          isCreate: false,
          isUpdate: false,
          isDelete: false,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.admission.term_payment,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("แจ้งค่าเทอม"),
          action: () => navigate(routeName.admission.term_payment),
          code: "term_payment",
          isCreate: false,
          isUpdate: true,
          isDelete: false,
          isView: true,
        },
        {
          icon: <UndoIcon sx={{ rotate: "180deg" }} />,
          pathName: routeName.admission.student_registration,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("ขึ้นทะเบียนนักศึกษา"),
          action: () => navigate(routeName.admission.student_registration),
          code: "student_registration",
          isCreate: false,
          isUpdate: true,
          isDelete: false,
          isView: true,
        },
      ]
    },
    // {
    //   text: t("ทะเบียนนักศึกษา"),
    //   icon: <img src={iconsNavbar.folder2} alt="icon2" />,
    //   action: () => navigate(routeName.admission.student_registration),
    //   pathName: routeName.admission.student_registration,
    //   permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
    //   code: "EntranceExamination",
    //   subItems: [
    //     {
    //       icon: <UndoIcon sx={{ rotate: "180deg" }} />,
    //       pathName: routeName.admission.student_registration_information,
    //       permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
    //       text: t("ข้อมูลทะเบียนนักศึกษา"),
    //       action: () => navigate(routeName.admission.student_registration_information),
    //     },
    //     {
    //       icon: <UndoIcon sx={{ rotate: "180deg" }} />,
    //       pathName: routeName.admission.student_registration,
    //       permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
    //       text: t("ขึ้นทะเบียนนักศึกษา"),
    //       action: () => navigate(routeName.admission.student_registration),
    //     },

    //   ]
    // },
    {
      text: 'จัดการระดับ/คณะ',
      icon: (
        <img
          src={iconsNavbar.layer}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.LevelFacultyManagement),
      pathName: routeName.admission.LevelFacultyManagement,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "LevelFacultyManagement",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: 'จัดการปีการศึกษา',
      icon: (
        <img
          src={iconsNavbar.calendar}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.ManageAcademicYear),
      pathName: routeName.admission.ManageAcademicYear,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "ManageAcademicYear",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: 'ตั้งค่าการเปิดหลักสูตร',
      icon: (
        <img
          src={iconsNavbar.menu_board}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.SetupCourseOpening),
      pathName: routeName.admission.SetupCourseOpening,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "SetupCourseOpening",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: 'ตั้งค่าค่าเทอม',
      icon: (
        <img
          src={iconsNavbar.wallet_money}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.SetTuitionFees),
      pathName: routeName.admission.SetTuitionFees,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "SetTuitionFees",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: 'จัดการช่องทางชำระเงิน',
      icon: (
        <img
          src={iconsNavbar.money_recive}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.ManagePayment),
      pathName: routeName.admission.ManagePayment,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "ManagePayment",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: 'จัดการข้อมูล PDPA',
      icon: (
        <img
          src={iconsNavbar.security}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.admission.ManagePDPA),
      pathName: routeName.admission.ManagePDPA,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "ManagePDPA",
      isCreate: false,
      isUpdate: true,
      isDelete: false,
      isView: true,
    },

    ...listItemsCmsWebsite,






    // {
    //   text: t("TOPIC.LIST_OF_APPLICANTS"),
    //   icon: <img src={iconsNavbar.icon1} alt="icon1" />,
    //   action: () => navigate(routeName.cms.ListOfApplicants),
    //   pathName: routeName.cms.ListOfApplicants,
    //   permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
    // },
    // {
    //   text: t("TOPIC.ENTRANCE_EXAMINATION"),
    //   icon: <img src={iconsNavbar.icon2} alt="icon2" />,
    //   action: () => navigate(routeName.cms.EntranceExamination),
    //   pathName: routeName.cms.EntranceExamination,
    //   permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
    //   code: "EntranceExamination",
    //   // subItems: [
    //   //   {
    //   //     icon: <img src={iconsNavbar.icon2} alt="icon2" />,
    //   //     pathName: "/test",
    //   //     permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
    //   //     text: "ทดสอบ",

    //   //     action: () => navigate("dawio"),
    //   //   },
    //   // ],
    // },


    {
      text: "ระบบ E-Library",
      icon: <LocalLibraryIcon />,
      action: () => { },
      pathName: "",
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR", "STUDENT"],
      code: "E_Library",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      subItems: [
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.books,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("หนังสือ"),
          action: () => navigate(routeName.e_library.books),
          code: "e_library_books",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.e_books,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("E-Book"),
          action: () => navigate(routeName.e_library.e_books),
          code: "e_library_e_books",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.journal,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("วารสาร"),
          action: () => navigate(routeName.e_library.journal),
          code: "e_library_journal",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.the_sis,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("วิทยานิพนธ์"),
          action: () => navigate(routeName.e_library.the_sis),
          code: "e_library_the_sis",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.audio_book,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("หนังสือเสียง"),
          action: () => navigate(routeName.e_library.audio_book),
          code: "e_library_audio_book",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.podcast,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("พอดแคสต์"),
          action: () => navigate(routeName.e_library.podcast),
          code: "e_library_podcast",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.video,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("วีดีโอ"),
          action: () => navigate(routeName.e_library.video),
          code: "e_library_video",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.books_shop_cart,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("ตะกร้าสินค้า"),
          action: () => navigate(routeName.e_library.books_shop_cart),
          code: "e_library_books_shop_cart",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.books_borrow,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("รายการยืม/จอง"),
          action: () => navigate(routeName.e_library.books_borrow),
          code: "e_library_books_borrow",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.search_global,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: t("การสืบค้นขั้นสูง"),
          action: () => navigate(routeName.e_library.search_global),
          code: "e_library_search_global",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ]

    },
    {
      text: "จัดการข้อมูล E-Library",
      icon: <SettingsApplicationsIcon />,
      action: () => { },
      pathName: "",
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "E_Library",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      subItems: [
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_books,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการหนังสือ"),
          action: () => navigate(routeName.e_library.manage_books),
          code: "e_library_search_global",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_e_books,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการ E-Book"),
          action: () => navigate(routeName.e_library.manage_e_books),
          code: "manage_e_books",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_the_ses,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการวิทยานิพนธ์"),
          action: () => navigate(routeName.e_library.manage_the_ses),
          code: "manage_the_ses",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_journal,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการวารสาร"),
          action: () => navigate(routeName.e_library.manage_journal),
          code: "manage_journal",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_podcast,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการพอดแคสต์"),
          action: () => navigate(routeName.e_library.manage_podcast),
          code: "manage_podcast",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_audio_book,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการหนังสือเสียง"),
          action: () => navigate(routeName.e_library.manage_audio_book),
          code: "manage_audio_book",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_videos,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการวีดีโอ"),
          action: () => navigate(routeName.e_library.manage_videos),
          code: "manage_videos",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_borrow,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการข้อมูลการยืมหนังสือ"),
          action: () => navigate(routeName.e_library.manage_borrow),
          code: "manage_borrow",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_orders,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการรายการสั่งซื้อ"),
          action: () => navigate(routeName.e_library.manage_orders),
          code: "manage_orders",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_library_type,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการหมวดหมู่"),
          action: () => navigate(routeName.e_library.manage_library_type),
          code: "manage_library_type",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_library_author,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการสำนักพิมพ์/ผู้เขียน/สังกัด"),
          action: () => navigate(routeName.e_library.manage_library_author),
          code: "manage_library_author",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_library_banner,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการ Banner"),
          action: () => navigate(routeName.e_library.manage_library_banner),
          code: "manage_library_banner",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_payment_channels,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("จัดการช่องทางการชำระเงิน"),
          action: () => navigate(routeName.e_library.manage_payment_channels),
          code: "manage_payment_channels",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.e_library.manage_report,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("รายงานการใช้ E-Library"),
          action: () => navigate(routeName.e_library.manage_report),
          code: "manage_report",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },

      ]
    },

    {
      text: t("TOPIC.PERSONNEL_MANAGEMENT"),
      icon: <img src={iconsNavbar.icon3} alt="icon3" />,
      action: () => navigate(routeName.cms.PersonnelManagement),
      pathName: routeName.cms.PersonnelManagement,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "PersonnelManagement",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_STUDENTS"),
      icon: <img src={iconsNavbar.icon5} alt="icon5" />,
      action: () => navigate(routeName.admission.student_registration_information),
      // action: () => navigate(routeName.cms.ManageStudents),
      pathName: routeName.admission.student_registration_information,
      // pathName: routeName.cms.ManageStudents,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "student_registration_information",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    // {
    //   text: t("TOPIC.MANAGE_STUDENTS"),
    //   icon: <img src={iconsNavbar.icon5} alt="icon5" />,
    //   action: () => navigate(routeName.cms.ManageStudents),
    //   pathName: routeName.cms.ManageStudents,
    //   permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
    // },
    {
      text: t("TOPIC.MANAGE_JOB_TITLES"),
      icon: <img src={iconsNavbar.icon7} alt="icon7" />,
      action: () => navigate(routeName.cms.ManageJobTitles),
      pathName: routeName.cms.ManageJobTitles,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "ManageJobTitles",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.ORGANIZATION_CHART_MANAGEMENT"),
      icon: <img src={iconsNavbar.icon6} alt="icon6" />,
      action: () => navigate(routeName.cms.OrganizationChartManagement),
      pathName: routeName.cms.OrganizationChartManagement,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "OrganizationChartManagement",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.ONLINE_LEAVE_SUBMISSION"),
      icon: <img src={iconsNavbar.sms_edit} alt="sms_edit" />,
      action: () => navigate(routeName.cms.OnlineLeaveSubmission),
      pathName: routeName.cms.OnlineLeaveSubmission,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "OnlineLeaveSubmission",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_ONLINE_LEAVE_SUBMISSION"),
      icon: <img src={iconsNavbar.folder} alt="folder" />,
      action: () => navigate(routeName.cms.OnlineLeaveSubmissionRequest),
      pathName: routeName.cms.OnlineLeaveSubmissionRequest,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "OnlineLeaveSubmissionRequest",
      isCreate: false,
      isUpdate: true,
      isDelete: false,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.SETTING_DATE_LEAVE"),
      icon: <img src={iconsNavbar.setting_4} alt="setting_4" />,
      action: () => navigate(routeName.cms.SettingLeaveDay),
      pathName: routeName.cms.SettingLeaveDay,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "SettingLeaveDay",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_lEAVE_TYPE"),
      icon: <img src={iconsNavbar.document_copy} alt="document_copy" />,
      action: () => navigate(routeName.cms.ManageLeaveType),
      pathName: routeName.cms.ManageLeaveType,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "ManageLeaveType",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },

    {
      text: t("TOPIC.TIME_RECORD_SYSTEM"),
      icon: <img src={iconsNavbar.brifecase_timer} alt="brifecase_timer" />,
      action: () => navigate(routeName.cms.TimeRecordSystem),
      pathName: routeName.cms.TimeRecordSystem,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "TimeRecordSystem",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_TIME_RECORD_SYSTEM"),
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.cms.ManageTimeRecordSystem),
      pathName: routeName.cms.ManageTimeRecordSystem,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "ManageTimeRecordSystem",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.LOGIN_HISTORY"),
      icon: <img src={iconsNavbar.login} alt="login" />,
      action: () => navigate(routeName.cms.LoginHistory),
      pathName: routeName.cms.LoginHistory,
      permission: ["ALL", "ADMIN", "HR", "EMPLOYEE", "ADVISOR"],
      code: "LoginHistory",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_CLASS_ROOM"),
      icon: <img src={iconsNavbar.people} alt="manage-class-room" />,
      action: () => navigate(routeName.cms.ManageClassRoom),
      pathName: routeName.cms.ManageClassRoom,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "ManageClassRoom",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    // {
    //   text: t("TOPIC.MANAGE_SUBJECT_TAUGHT"),
    //   icon: <img src={iconsNavbar.login} alt="login" />,
    //   action: () => navigate(routeName.cms.LoginHistory),
    //   pathName: routeName.cms.LoginHistory,
    //   permission: ["ALL", "ADMIN"],
    // },
    // {
    //   text: t("TOPIC.MANAGE_TEACHER_EVALUATION_SCORES"),
    //   icon: <img src={iconsNavbar.login} alt="login" />,
    //   action: () => navigate(routeName.cms.LoginHistory),
    //   pathName: routeName.cms.LoginHistory,
    //   permission: ["ALL", "ADMIN"],
    // },
    {
      text: t("TOPIC.HISTORY_USING_CLASS_SCHEDULE"),
      icon: <img src={iconsNavbar.document} alt="login" />,
      action: () => navigate(routeName.cms.history_using_class_shedule),
      pathName: routeName.cms.history_using_class_shedule,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "history_using_class_shedule",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.MANAGE_TEACHER_EVALUATION_FORM"),
      icon: <img src={iconsNavbar.document} alt="login" />,
      action: () => navigate(routeName.cms.ManageEvaluationForm),
      pathName: routeName.cms.ManageEvaluationForm,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "ManageEvaluationForm",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: "ระบบแจ้งเตือน",
      icon: <NotificationsNoneIcon />,
      action: () => navigate(routeName.cms.Notifications),
      pathName: routeName.cms.Notifications,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "Notifications",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },
    {
      text: t("TOPIC.COURSE_MANAGEMENT"),
      icon: (
        <img
          src={iconsNavbar.courseManagementIcon}
          alt="courseManagementIcon"
        />
      ),
      action: () => navigate(routeName.cms.courseManagement),
      pathName: routeName.cms.courseManagement,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "courseManagement",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      // subItems: []
    },



    {
      text: t("TOPIC.ADVISOR_SYSTEM"),
      icon: <img src={iconsNavbar.advisor} alt="icon2" />,
      action: () => navigate(routeName.cms.AdvisorSystem),
      pathName: routeName.cms.AdvisorSystem,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      code: "AdvisorSystem",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.manageAdvisors,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.MANAGE_ADVISOR"),
          action: () => navigate(routeName.cms.manageAdvisors),
          code: "manageAdvisors",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.manageConsultationTypes,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.MANAGE_CONSULTATION_TYPES"),
          action: () => navigate(routeName.cms.manageConsultationTypes),
          code: "manageConsultationTypes",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.manageDocuments,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.MANAGE_DOCUMENTS"),
          action: () => navigate(routeName.cms.manageDocuments),
          code: "manageDocuments",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.consultingReport,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          text: t("TOPIC.CONSULTING_REPORT"),
          action: () => navigate(routeName.cms.consultingReport),
          code: "consultingReport",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ],
    },
    {
      text: "ระบบร้องเรียน",
      icon: <img src={icons.sms_tracking} alt="icon2" />,
      action: () => navigate(routeName.cms.complaintSystem),
      pathName: routeName.cms.complaintSystem,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
      code: "complaintSystem",
      // code: "AdvisorSystemds",
      subItems: [
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.students.complaintSubmit,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "ส่งเรื่องร้องเรียน",
          action: () => navigate(routeName.students.complaintSubmit),
          code: "complaintSubmit",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.complaintSystem,
          permission: ["ADMIN", "EMPLOYEE", "ADVISOR"],
          text: "จัดการข้อมูลการร้องเรียน",
          action: () => navigate(routeName.cms.complaintSystem),
          code: "complaintSystem",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.complaintsType,
          permission: ["ADMIN", "EMPLOYEE", "ADVISOR"],
          text: "จัดการหมวดหมู่เรื่องร้องเรียน",
          action: () => navigate(routeName.cms.complaintsType),
          code: "complaintsType",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.complaintsStatistics,
          permission: ["ADMIN", "EMPLOYEE", "ADVISOR"],
          text: "สถิติการร้องเรียน",
          action: () => navigate(routeName.cms.complaintsStatistics),
          code: "complaintsStatistics",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ],
    },
    // {
    //   text: "ระบบ Edpex",
    //   icon: <img src={icons.sms_tracking} alt="icon2" />,
    //   action: () => navigate(routeName.cms.edPexDisplayPage),
    //   pathName: routeName.cms.edPexDisplayPage,
    //   permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
    //   // code: "AdvisorSystemds",
    //   subItems: [
    //     {
    //       icon: <img src={iconsNavbar.icon2} alt="icon2" />,
    //       pathName: routeName.cms.edPexDisplayPage,
    //       permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
    //       text: "หน้าแสดงผล",
    //       action: () => navigate(routeName.cms.edPexDisplayPage),
    //     },
    //   ],
    // },
    {
      text: t("TOPIC.STUDENT.SCHEDULE"),
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.students.CourseofStudy),
      pathName: routeName.students.CourseofStudy,
      permission: ["ALL", "STUDENT"],
      code: "CourseofStudy",
      isCreate: false,
      isUpdate: false,
      isDelete: false,
      isView: true,
    },



    // TODO : จัดการข้อมูลคอร์สออนไลน์
    {
      text: "จัดการข้อมูลคอร์สออนไลน์",
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.students.CourseofStudy),
      pathName: "course",
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
      code: "CourseofStudy",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: "",
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการคอร์สเรียน",
          action: () => navigate(routeName.cms.OnlineCourseManagement),
          code: "OnlineCourseManagement",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_payment,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการรายการสั่งซื้อ",
          action: () => navigate(routeName.cms.course_online_payment),
          code: "course_online_payment",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_payment_channels,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการช่องทางการชำระเงิน",
          action: () => navigate(routeName.cms.course_online_payment_channels),
          code: "course_online_payment_channels",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_course_type,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการประเภทคอร์สเรียน",
          code: "course_online_course_type",
          action: () => navigate(routeName.cms.course_online_course_type),
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_tags,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการแท็ก",
          action: () => navigate(routeName.cms.course_online_tags),
          code: "course_online_tags",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_quiz,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการแบบทดสอบ",
          action: () => navigate(routeName.cms.course_online_quiz),
          code: "course_online_quiz",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_surveys,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการแบบสำรวจ",
          action: () => navigate(routeName.cms.course_online_surveys),
          code: "course_online_surveys",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: "",
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "จัดการวุฒิบัตร",
          action: () => navigate(routeName.cms.OnlineCourseDiploma),
          code: "OnlineCourseDiploma",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt="icon2" />,
          pathName: routeName.cms.course_online_statistics,
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          text: "สถิติ",
          action: () => navigate(routeName.cms.course_online_statistics),
          code: "course_online_statistics",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ]
    },
    // TODO : จัดการข้อมูลคอร์สออนไลน์
    {
      text: "ระบบคอร์สออนไลน์",
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.students.OnlineCourse),
      pathName: routeName.students.OnlineCourse,
      permission: ["ALL", "STUDENT"],
      code: "OnlineCourse",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,

    },
    {
      text: "คอร์สออนไลน์ของท่าน",
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.students.MyOnlineCourse),
      pathName: routeName.students.MyOnlineCourse,
      permission: ["ALL", "STUDENT"],
      code: "MyOnlineCourse",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,

    },
    {
      text: "ตะกร้าสินค้า",
      icon: <img src={iconsNavbar.video_time} alt="video_time" />,
      action: () => navigate(routeName.students.ShoppingCart),
      pathName: routeName.students.ShoppingCart,
      permission: ["ALL", "STUDENT"],
      code: "ShoppingCart",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,

    },





    {
      text: t("TOPIC.ADVISOR.SUBJECT_TAUGHT"),
      icon: <img src={iconsNavbar.folder} alt="icon1" />,
      action: () => navigate(routeName.advisor.SubjectTaught),
      pathName: routeName.advisor.SubjectTaught,
      permission: ["ALL", "ADVISOR"],
      code: "SubjectTaught",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("TOPIC.STUDENT.TEACHER_EVALUATION_SCORES"),
      icon: <img src={iconsNavbar.star} alt="advisor" />,
      action: () => navigate(routeName.advisor.TeacherEvaluationScores),
      pathName: routeName.advisor.TeacherEvaluationScores,
      permission: ["ALL", "ADMIN", "EMPLOYEE",],
      code: "TeacherEvaluationScores",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("TOPIC.STUDENT.EVALUATION_SCORE_FROM_STUDENTS"),
      icon: <img src={iconsNavbar.star} alt="advisor" />,
      action: () => navigate(routeName.advisor.EvaluationScoresFromStudents),
      pathName: routeName.advisor.EvaluationScoresFromStudents,
      permission: ["ALL", "ADVISOR"],
      code: "EvaluationScoresFromStudents",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("TOPIC.STUDENT.ADVISOR"),
      icon: <img src={iconsNavbar.advisor} alt="advisor" />,
      action: () => navigate(routeName.student.chooseAdvisor),
      pathName: routeName.student.chooseAdvisor,
      permission: ["ALL", "STUDENT"],
      code: "chooseAdvisor",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    // {
    //   text: t("TOPIC.ADVISOR.STUDENT_EVALUATION_SCORE"),
    //   icon: <img src={iconsNavbar.icon1} alt="icon1" />,
    //   action: () => navigate(routeName.cms.ListOfApplicants),
    //   pathName: routeName.cms.ListOfApplicants,
    //   permission: ["ALL", "ADVISOR"],
    // },
    {
      text: t("TOPIC.ADVISOR_SYSTEM"),
      icon: <img src={iconsNavbar.advisor} alt="icon2" />,
      action: () => navigate(routeName.advisor.manageAdvisorRequest),
      pathName: routeName.advisor.manageAdvisorRequest,
      permission: ["ALL", "ADVISOR"],
      code: "manageAdvisorRequest",
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    {
      text: t("TOPIC.COURSE_OF_STUDY"), icon: <img src={iconsNavbar.login} alt='login' />, action: () => navigate(routeName.cms.CourseofStudy), pathName: routeName.cms.CourseofStudy,
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
      isCreate: true,
      code: "CourseofStudy",
      isUpdate: true,
      isDelete: true,
      isView: true,
    },
    // {
    //   text: t("ตารางเรียน"), icon: <img src={iconsNavbar.login} alt='login' />, action: () => navigate(routeName.students.CourseofStudy), pathName: routeName.students.CourseofStudy,
    //   permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
    // },
    // booking rom
    {
      text: t("TOPIC.BOOKING_ROOM"), icon: <img src={iconsNavbar.document} alt='icon2' />, action: () => navigate(routeName.cms.BookingRoom), pathName: routeName.cms.BookingRoom,
      code: 'Booking',
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoom,
          text: t("TOPIC.BOOKING_ROOM_DETAIL"),
          action: () => navigate(routeName.cms.BookingRoom),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          code: "BookingRoom",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomRequestMangement,
          text: t("TOPIC.BOOKING_ROOM_REQUEST_MANAGEMENT"),
          action: () => navigate(routeName.cms.BookingRoomRequestMangement),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          code: "BookingRoomRequestMangement",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomManagement,
          text: t("TOPIC.BOOKING_ROOM_MANAGEMENT"),
          action: () => navigate(routeName.cms.BookingRoomManagement),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          code: "BookingRoomManagement",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomDeviceManagement,
          text: t("TOPIC.BOOKING_ROOM_DEVICE_MANAGEMENT"),
          action: () => navigate(routeName.cms.BookingRoomDeviceManagement),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          code: "BookingRoomDeviceManagement",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomServiceFeesMangement,
          text: t("TOPIC.BOOKING_ROOM_SERVICE_FEES_MANAGEMENT"),
          action: () => navigate(routeName.cms.BookingRoomServiceFeesMangement),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          code: "BookingRoomServiceFeesMangement",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomPaymentChannelManagement,
          text: t("TOPIC.BOOKING_ROOM_PAYMENT_CHANNEL_MANAGEMENT"),
          action: () => navigate(routeName.cms.BookingRoomPaymentChannelManagement),
          code: "BookingRoomPaymentChannelManagement",
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR", "STUDENT"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.BookingRoomUsageReports,
          text: t("TOPIC.BOOKING_ROOM_USAGE_REPORTS"),
          action: () => navigate(routeName.cms.BookingRoomUsageReports),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          code: "BookingRoomUsageReports",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ]
    },
    // 
    // {
    //   text: "E-Meeting", icon: <img src={iconsNavbar.icon2} alt='icon2' />, action: () => navigate(routeName.cms.MeetingCalendar), pathName: routeName.cms.MeetingCalendar,
    //   code: 'EMeeting_STUDENT',
    //   permission: ["ALL", "STUDENT","ADVISOR"],
    //   isCreate: true,
    //   isUpdate: true,
    //   isDelete: true,
    //   isView: true,
    //   subItems: [

    //   ]
    // },
    {
      text: "E-Meeting", icon: <img src={iconsNavbar.icon2} alt='icon2' />, action: () => navigate(routeName.cms.MeetingCalendar), pathName: routeName.cms.MeetingCalendar,
      code: 'EMeeting_ADMIN',
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.MeetingCalendar,
          text: t("TOPIC.MEETING_CALENDAR") + '  (เจ้าหน้าที่)',
          action: () => navigate(routeName.cms.MeetingCalendar),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          code: 'EMeeting_ADMIN_CALENDAR',
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.students.MeetingCalendar,
          text: t("TOPIC.MEETING_CALENDAR"),
          action: () => navigate(routeName.students.MeetingCalendar),
          permission: ["ALL", "ADMIN", "EMPLOYEE", 'ADVISOR'],
          code: 'EMeeting_STUDENT_CALENDAR',
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.ManageMeetingPositions,
          text: t("TOPIC.MANAGE_MEETING_POSITIONS"),
          action: () => navigate(routeName.cms.ManageMeetingPositions),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          code: "ManageMeetingPositions",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.ManageMeetingCategories,
          text: t("TOPIC.MANAGE_MEETING_CATEGORIES"),
          action: () => navigate(routeName.cms.ManageMeetingCategories),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          code: "ManageMeetingCategories",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.ManageSampleFiles,
          text: t("TOPIC.MANAGE_SAMPLE_FILES"),
          action: () => navigate(routeName.cms.ManageSampleFiles),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          code: "MANAGE_SAMPLE_FILES",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ]
    },
    {
      text: "ระบบ E-Thesis", icon: <img src={iconsNavbar.icon2} alt='icon2' />, action: () => navigate(routeName.cms.EThesisLibrary), pathName: routeName.cms.EThesisLibrary, code: 'EThesis',
      permission: ["ALL", "STUDENT"],
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [

        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.students.EThesisLibrary,
          text: t("ห้องสมุด E-Thesis"),
          action: () => navigate(routeName.students.EThesisLibrary),
          permission: ["ALL", "STUDENT"],
          code: "EThesisLibrary",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.students.ScheduleCalenda,
          text: t("ปฏิทินตารางการสอบ"),
          action: () => navigate(routeName.students.ScheduleCalenda),
          permission: ["ALL", "STUDENT"],
          code: "ScheduleCalenda",
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.students.EThesisProgress,
          text: t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์"),
          code: "EThesisProgress",
          action: () => navigate(routeName.students.EThesisProgress),
          permission: ["ALL", "STUDENT"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.students.RulesRegulations,
          text: t("รูปแบบ/กฎระเบียบข้อบังคับ"),
          code: "RulesRegulations",
          action: () => navigate(routeName.students.RulesRegulations),
          permission: ["ALL", "STUDENT"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ]
    },
    {
      text: "ระบบ E-Thesis", icon: <img src={iconsNavbar.icon2} alt='icon2' />, action: () => navigate(routeName.cms.EThesisLibrary), pathName: routeName.cms.EThesisLibrary, code: 'EThesis',
      permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [

        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.EThesisLibrary,
          text: t("ห้องสมุด E-Thesis"),
          code: "EThesisLibrary",
          action: () => navigate(routeName.cms.EThesisLibrary),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.RulesRegulations,
          text: t("รูปแบบ/กฎระเบียบข้อบังคับ"),
          code: "RulesRegulations",
          action: () => navigate(routeName.cms.RulesRegulations),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },

        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.ScheduleCalenda,
          text: t("ปฏิทินตารางการสอบ"),
          code: "ScheduleCalenda",
          action: () => navigate(routeName.cms.ScheduleCalenda),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.EThesisProgress,
          text: t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์"),
          code: "EThesisProgress",
          action: () => navigate(routeName.cms.EThesisProgress),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.EThesisCategories,
          text: t("จัดการหมวดหมู่"),
          code: "EThesisCategories",
          action: () => navigate(routeName.cms.EThesisCategories),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR",],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.EThesisType,
          text: t("จัดการประเภท"),
          code: "EThesisType",
          action: () => navigate(routeName.cms.EThesisType),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },

        {
          icon: <img src={iconsNavbar.icon2} alt='icon2' />,
          pathName: routeName.cms.EThesisHistory,
          text: t("ประวัติการเข้าชม"),
          code: "EThesisHistory",
          action: () => navigate(routeName.cms.EThesisHistory),
          permission: ["ALL", "ADMIN", "EMPLOYEE", "ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },


      ]
    },
    // edpex  ADVISOR
    {
      text: "ระบบ EdPEx",
      icon: <img src={iconsNavbar.folder} alt="icon3" />, // change to appropriate icon
      pathName: routeName.cms.edpexResultDisplay,
      code: "EdPEx",
      permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
      isCreate: true,
      isUpdate: true,
      isDelete: true,
      isView: true,
      subItems: [
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexResultDisplay,
          text: t("หน้าแสดงผล"),
          code: "edpexResultDisplay",
          action: () => navigate(routeName.cms.edpexResultDisplay),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexResponsibleProjects,
          text: t("โครงการ/กิจกรรม/งานที่รับผิดชอบ"),
          code: "edpexResponsibleProjects",
          action: () => navigate(routeName.cms.edpexResponsibleProjects),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexAddResponsiblePerson,
          text: t("เพิ่มผู้รับผิดชอบ"),
          code: "edpexAddResponsiblePerson",
          action: () => navigate(routeName.cms.edpexAddResponsiblePerson),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexAddProject,
          text: t("เพิ่มโครงการ/กิจกรรม/งาน"),
          code: "edpexAddProject",
          action: () => navigate(routeName.cms.edpexAddProject),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexSpecialEditRequest,
          text: t("การขอแก้ไขพิเศษ"),
          code: "edpexSpecialEditRequest",
          action: () => navigate(routeName.cms.edpexSpecialEditRequest),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexCriteria,
          text: t("เกณฑ์คะแนน EdPEx"),
          code: "edpexCriteria",
          action: () => navigate(routeName.cms.edpexCriteria),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexMission,
          text: t("พันธกิจ"),
          code: "edpexMission",
          action: () => navigate(routeName.cms.edpexMission),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexSampleProjectData,
          text: t("จัดการข้อมูลตัวอย่างการเพิ่มโครงการ"),
          code: "edpexSampleProjectData",
          action: () => navigate(routeName.cms.edpexSampleProjectData),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
        {
          icon: <FiberManualRecordIcon sx={{ fontSize: "14px" }} />,
          pathName: routeName.cms.edpexSampleSummaryData,
          text: t("จัดการข้อมูลตัวอย่างการสรุปผล"),
          code: "edpexSampleSummaryData",
          action: () => navigate(routeName.cms.edpexSampleSummaryData),
          permission: ["ALL", "ADMIN", "EMPLOYEE","ADVISOR"],
          isCreate: true,
          isUpdate: true,
          isDelete: true,
          isView: true,
        },
      ],
    },
  ];
  // const data_value = listItems.map((list) => {
  //   return {
  //     "name": list?.text,
  //     "code": list.code,
  //     "permit": false,
  //     'actions': [
  //       {
  //         "name": "ดู",
  //         "code": `${list.code}.View`,
  //         "permit": false,
  //         "sub": [],
  //         "actions": []
  //       },
  //       {
  //         "name": "เพิ่ม",
  //         "code": `${list.code}.Create`,
  //         "permit": false,
  //         "sub": [],
  //         "actions": []
  //       },
  //       {
  //         "name": "แก้ไข",
  //         "code": `${list.code}.Update`,
  //         "permit": false,
  //         "sub": [],
  //         "actions": []
  //       },
  //       {
  //         "name": "ลบ",
  //         "code": `${list.code}.Deleted`,
  //         "permit": false,
  //         "sub": [],
  //         "actions": []
  //       },
  //     ],
  //     'subMenu': list.subItems ? list.subItems?.map((sub) => {
  //       return {
  //         "name": sub.text,
  //         "code": sub.code,
  //         "permit": false,
  //         'actions': [
  //           ...(sub.isView ? [
  //             {
  //               "name": "ดู",
  //               "code": `${sub.code}.View`,
  //               "permit": false,
  //               "sub": [],
  //               "actions": []
  //             },
  //           ] : []),
  //           ...(sub.isCreate ? [
  //             {
  //               "name": "เพิ่ม",
  //               "code": `${sub.code}.Create`,
  //               "permit": false,
  //               "sub": [],
  //               "actions": []
  //             },
  //           ] : []),
  //           ...(sub.isUpdate ? [
  //             {
  //               "name": "แก้ไข",
  //               "code": `${sub.code}.Update`,
  //               "permit": false,
  //               "sub": [],
  //               "actions": []
  //             },
  //           ] : []),
  //           ...(sub.isDelete ? [
  //             {
  //               "name": "ลบ",
  //               "code": `${sub.code}.Deleted`,
  //               "permit": false,
  //               "sub": [],
  //               "actions": []
  //             },
  //           ] : []),
  //         ],
  //         'subMenu': sub?.subItems && sub?.subItems?.map((tr) => {
  //           return {
  //             "name": tr.text,
  //             "code": tr.code,
  //             "permit": false,
  //             'actions': [
  //               ...(tr.isView ? [
  //                 {
  //                   "name": "ดู",
  //                   "code": `${tr.code}.View`,
  //                   "permit": false,
  //                   "sub": [],
  //                   "actions": []
  //                 },
  //               ] : []),
  //               ...(tr.isCreate ? [
  //                 {
  //                   "name": "เพิ่ม",
  //                   "code": `${tr.code}.Create`,
  //                   "permit": false,
  //                   "sub": [],
  //                   "actions": []
  //                 },
  //               ] : []),
  //               ...(tr.isUpdate ? [
  //                 {
  //                   "name": "แก้ไข",
  //                   "code": `${tr.code}.Update`,
  //                   "permit": false,
  //                   "sub": [],
  //                   "actions": []
  //                 },
  //               ] : []),
  //               ...(tr.isDelete ? [
  //                 {
  //                   "name": "ลบ",
  //                   "code": `${tr.code}.Deleted`,
  //                   "permit": false,
  //                   "sub": [],
  //                   "actions": []
  //                 },
  //               ] : []),
  //             ],
  //           }
  //         }) || [],
  //       }
  //     }) : []
  //   }
  // })
  // console.log(JSON.stringify(data_value), 'data_value')


  const handleToggleExpand = (text: string) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [text]: !prevExpanded[text],
    }));
  };

  const shouldExpand = (currentPath: string, items: ListItem[]): boolean => {
    for (const item of items) {
      if (item.pathName === currentPath) {
        return true;
      }
      if (item.subItems && shouldExpand(currentPath, item.subItems)) {
        return true;
      }
    }
    return false;
  };

  // const shouldExpandSubMenu = (currentPath: string, subItems: SubItem[]): boolean => {
  //     for (const subItem of subItems) {
  //         if (subItem.pathName === currentPath) {
  //             return true;
  //         }
  //         if (subItem.subItems && shouldExpandSubMenu(currentPath, subItem.subItems)) {
  //             return true;
  //         }
  //     }
  //     return false;
  // };

  useEffect(() => {
    const initialExpanded: { [key: string]: boolean } = {};
    const expandItems = (items: (ListItem | SubItem)[]) => {
      items.forEach((item) => {
        if (item.subItems && shouldExpand(currentPath, item.subItems)) {
          initialExpanded[item.text] = true;
          expandItems(item.subItems);
        }
      });
    };
    expandItems(listItems);
    setExpanded(initialExpanded);
  }, [currentPath]);

  const handleExpand = (text: string) => {
    setExpanded((prevExpanded) => ({
      ...prevExpanded,
      [text]: !prevExpanded[text],
    }));
  };

  const convertHexToRGBA = (hex: string, opacity: number) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const renderSubItems = (subItems: SubItem[], paddingLeft: number) => {
    // const is_cms_website = subItems?.find((x) => x.pathName === '/manage-website/dashboard');
    // console.log(is_cms_website, 'is_cms_website')

    return subItems.map((subItem) => {
      const has_permit = checkPermission(subItem.code || "", permission)
      const is_student = USER_TYPE.STUDENT === userRole;
      if (!has_permit.isView && !is_student) return <></>
      return (
        <>
          <Box
            sx={{
              backgroundColor: convertHexToRGBA(colors.subPrimary, 0.2),
            }}
            key={subItem.text}
          >
            <ListItemButton
              sx={{
                backgroundColor: (currentPath === subItem.pathName) ? colors.themeSecondColor : undefined,
                pl: paddingLeft,
                "&:hover": {
                  // opacity: 0.6,
                  backgroundColor: colors.subPrimary,
                  color: colors.white,
                  "& .image-icons-custom": {
                    filter: subItem.subItems ? "" : "brightness(0) invert(1)",
                  },
                },
              }}
              onClick={() => {
                subItem.action?.();
                if (subItem.subItems) {
                  handleExpand(subItem.text);
                }
              }}
            >
              <ListItemIcon>
                {subItem?.icon ? (
                  <Box sx={{
                    color: (currentPath === subItem.pathName) ? colors.white : undefined,
                  }}>
                    {subItem.icon}
                  </Box>
                ) : (
                  <FiberManualRecordIcon
                    sx={{
                      color: (currentPath === subItem.pathName) ? colors.white : undefined,
                      fontSize: "12px",
                    }}
                  />
                )}
              </ListItemIcon>
              <ListItemText primary={<Typography sx={{
                color: (currentPath === subItem.pathName) ? colors.white : undefined,

              }}>{subItem.text}</Typography>} />
              {subItem.subItems ? (
                expanded[subItem.text] ? (
                  <ExpandLess />
                ) : (
                  <ExpandMore />
                )
              ) : null}
            </ListItemButton>
            {subItem.subItems && (
              <Collapse in={expanded[subItem.text]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {renderSubItems(subItem.subItems, paddingLeft + 2)}
                </List>
              </Collapse>
            )}
          </Box>
        </>
      )
    }
    );
  };

  const setLocalPath = (path: string) => {
    localStorage.setItem("CURRENT_PATH", path);
  };
  const getCurrentPath = (): string | null => {
    const CURRENT_PATH: string | null = currentPath || localStorage.getItem(`CURRENT_PATH`);
    return CURRENT_PATH;
  };

  useEffect(() => {
    if (matches) {
      dispatch(unsetShowNavbar());
    } else if (fullScreen) {
      dispatch(setShowNavbar());
    }
  }, [matches]);

  return (
    <Box
      sx={{
        position: matches ? "absolute" : "relative",
        display: "flex",
        flexDirection: "column",
        height: "auto",
        transition: "all .5 ease",
      }}
    >
      <Drawer
        sx={{
          width: open ? drawerWidth : 65,
          flexShrink: 0,
          flexGrow: 1,
          boxShadow:
            "0px 3px 2px 1px rgba(0,0,0,0.12),0px 1px 0px -2px rgba(0,0,0,.12)",
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            overflow: "auto",
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
        onClose={() => {
          dispatch(unsetShowNavbar());
        }}
      >
        {/* MANAGE_WEB_SITE */}
        <DrawerHeader style={{ padding: "0.3em 1rem" }} className="flex w-full">
          <div onClick={() => navigate(routeName.main.home)} className="flex w-full cursor-pointer justify-center items-center flex-1">
            <img src={iconsHeader.logo} alt="logo" />
          </div>
          <IconButton onClick={() => dispatch(unsetShowNavbar())}>
            {theme.direction === "ltr" ? (
              <KeyboardArrowLeftIcon />
            ) : (
              <KeyboardArrowRightIcon />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {listItems
            ?.filter((list) => list.permission.includes(userRole.toUpperCase()))
            .map((item, index) => {
              const has_permit = checkPermission(item.code || "", permission);
              const is_student = USER_TYPE.STUDENT === userRole;
              if (!has_permit.isView && !is_student) return <></>
              return (
                <React.Fragment key={index}>
                  {
                    <>
                      <ListItem
                        disablePadding
                        sx={{
                          display: "block",
                        }}
                      >
                        <ListItemButton
                          onClick={() => {
                            if (item.subItems) {
                              handleToggleExpand(item.text);
                              setLocalPath(item?.pathName);
                            } else {
                              item.action && item.action();
                              setLocalPath(item?.pathName);
                              if (matches) {
                                dispatch(unsetShowNavbar());
                              }
                            }
                          }}
                          sx={{
                            backgroundColor:
                              getCurrentPath() === item.pathName
                                ? colors.subPrimary
                                : "",
                            color:
                              getCurrentPath() === item.pathName
                                ? colors.white
                                : "",
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            "&:hover": {
                              // opacity: 0.6,
                              backgroundColor: colors.subPrimary,
                              color: colors.white,
                              "& .image-icons-custom": {
                                filter: item?.subItems
                                  ? ""
                                  : "brightness(0) invert(1)",
                              },
                            },
                          }}
                        >
                          <ListItemIcon
                            className="image-icons-custom"
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              filter:
                                getCurrentPath() === item.pathName
                                  ? "brightness(0) invert(1)"
                                  : "",
                            }}
                          >
                            {item.icon}
                          </ListItemIcon>
                          <ListItemText
                            disableTypography
                            primary={
                              <Typography
                                sx={{
                                  opacity: open ? 1 : 0,
                                  color:
                                    getCurrentPath() === item.pathName
                                      ? colors.white
                                      : "",
                                }}
                              >
                                {item.text}
                              </Typography>
                            }
                          />
                          {item.subItems &&
                            (expanded[item.text] ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            ))}
                        </ListItemButton>
                        {item.subItems && (
                          <Collapse
                            in={expanded[item.text]}
                            timeout="auto"
                            unmountOnExit
                          >
                            <List component="div" disablePadding>
                              {/* {renderSubItems(item.subItems, 4)} */}
                              {renderSubItems(item.subItems?.filter((x) => x?.checkPermission ? permission?.find((y) => y.code === x.code)?.permit : x.permission.includes(userRole.toUpperCase())), 4)}
                            </List>
                          </Collapse>
                        )}
                      </ListItem>
                      <Divider />
                    </>
                  }
                </React.Fragment>
              )
            })}
        </List>
      </Drawer>
      {!matches && (
        <Box
          sx={{
            width: "100%",
            boxShadow:
              "0px 3px 2px 2px rgba(0,0,0,0.12),0px 1px 0px -2px rgba(0,0,0,.12)",
            height: "100%",
            overflowY: "auto",
            display: "flex",
            pt: 2,
            flexDirection: "column",
            gap: 2.2,
            alignItems: "center",
          }}
        >
          {listItems?.map((list, i) => {
            return (
              <>
                {/* {list?.permit && */}
                <ListItem
                  key={i}
                  onClick={() => {
                    if (list.action) {
                      list.action();
                    }
                    dispatch(setShowNavbar());
                  }}
                  sx={{
                    // backgroundColor: currentPath === list.pathName ? colors.subPrimary : '',
                    "&:hover": {
                      backgroundColor: list?.subItems ? "" : colors.subPrimary,
                      color: colors.white,
                    },
                  }}
                  disablePadding
                  className="d-flex justify-content-center align-items-center"
                >
                  <ListItemButton>
                    <ListItemIcon
                      sx={{ display: "flex", justifyContent: "center" }}
                    >
                      {list.icon}
                    </ListItemIcon>
                  </ListItemButton>
                </ListItem>
                {/* } */}
              </>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default Navbar;
